import { apiPeUrl } from '@/environment/environment';

export const apiConstants = {
  fetchGuide: 'mock-data/competer/guide.json',
  fetchTags: 'mock-data/competer/tags.json',
  fetchArtefacts: 'mock-data/competer/artefacts.json',
  fetchArtefact: 'mock-data/competer/artefact.json',
  fetchArtifactUnit: 'mock-data/competer/artefactUnit.json',
  dash: apiPeUrl+'productbase/overview',
  stock: apiPeUrl+'apis/search',
  stocksearch: apiPeUrl+'apis/search',
  scf: apiPeUrl+'apis/search',
  srf: apiPeUrl+'apis/search',
  cdl: apiPeUrl+'apis/search',
  bdl: apiPeUrl+'apis/search',
  sku: apiPeUrl+'productbase/sku',
  mpi: apiPeUrl+'productbase/recheck',
  cpi: apiPeUrl+'productbase/levispriceindex/category',
  gpi: apiPeUrl+'productbase/levispriceindex/gender',
  spi: apiPeUrl+'productbase/levispriceindex/color',
  // amb: apiPeUrl+'productbase/levispriceindex/color',
  // cpi: 'mock-data/competer/cpi.json',
  // gpi: 'mock-data/competer/gpi.json',
  // spi: 'mock-data/competer/spi.json',
  amb: 'mock-data/competer/amb.json',

  
  dash1: 'mock-data/competer/overview',
  stock1: 'mock-data/competer/stock',
  sku1: 'mock-data/competer/sku'
};
